namespace TabAurous.Retail {
    export interface POSApprovalRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        AutoPosting?: boolean;
        PartyId?: number;
        POSCustomerId?: number;
        PosCustomerCode?: string;
        CustomerName?: string;
        Email?: string;
        BirthDate?: string;
        Anniversary?: string;
        PanNumber?: string;
        Address?: string;
        Mobile?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        ReceiptAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        BillAddId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: POSApprovalItemsRow[];
        ReceiptDetails?: ReceiptDetailsRow[];
        DepartmentId?: number;
        RefVoucherId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        ProductItemImage?: string;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        Username?: string;
        RoundOff?: number;
        PostingDate?: string;
        IsPosted?: boolean;
        MF?: number;
    }

    export namespace POSApprovalRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Retail.POSApproval';
        export const deletePermission = 'Retail:POSApproval:Delete';
        export const insertPermission = 'Retail:POSApproval:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSApproval:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            PosCustomerCode = "PosCustomerCode",
            CustomerName = "CustomerName",
            Email = "Email",
            BirthDate = "BirthDate",
            Anniversary = "Anniversary",
            PanNumber = "PanNumber",
            Address = "Address",
            Mobile = "Mobile",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            ReceiptAmount = "ReceiptAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            BillAddId = "BillAddId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            ReceiptDetails = "ReceiptDetails",
            DepartmentId = "DepartmentId",
            RefVoucherId = "RefVoucherId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            ProductItemImage = "ProductItemImage",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            Username = "Username",
            RoundOff = "RoundOff",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            MF = "MF"
        }
    }
}
